import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { AbstractBaseDialogComponent } from '../dialog/abstract-base-dialog-component.directive';
import { DialogComponent } from '../dialog/dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { getWhatsappLink } from '../../utils/utils';
import { PublicConfigService } from '@core/services/public-config/public-config.service';

@Component({
  selector: 'hd-contact-us-dialog',
  standalone: true,
  imports: [DialogComponent, TranslateModule],
  templateUrl: './contact-us-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsDialogComponent extends AbstractBaseDialogComponent {
  private readonly configService = inject(PublicConfigService);

  protected readonly contactEmail = computed(
    () => this.configService.publicConfig$$()?.contactInfo.infoEmailAddress,
  );

  protected readonly contactPhone = computed(
    () => this.configService.publicConfig$$()?.contactInfo.phoneNumber,
  );

  protected readonly whatsappLink = computed(() =>
    getWhatsappLink(this.contactPhone()),
  );
}
